import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = ({ onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
            setSubmitStatus({ type: 'error', message: 'Please fill in all fields' });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setSubmitStatus({ type: 'error', message: 'Please enter a valid email address' });
            return;
        }

        setIsSubmitting(true);

        try {
            // Send to n8n webhook
            const webhookResponse = await fetch('https://n8n-rqkz.onrender.com/webhook/64daa908-517d-44dc-8158-f7c0170c77ff', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    message: formData.message,
                    timestamp: new Date().toISOString(),
                    source: 'CLIP AND GO Contact Form'
                })
            });

            if (webhookResponse.ok) {
                setSubmitStatus({ type: 'success', message: 'Thank you! Your message has been sent successfully.' });
                setFormData({ name: '', email: '', message: '' });
                setTimeout(() => {
                    onClose();
                }, 2000);
            } else {
                setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
            }
        } catch (error) {
            console.error('Error:', error);
            setSubmitStatus({ type: 'error', message: 'An error occurred. Please try again later.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-overlay" onClick={onClose}>
            <div className="contact-container" onClick={(e) => e.stopPropagation()}>
                <button className="contact-close" onClick={onClose}>✕</button>

                <div className="contact-content">
                    <h1>Contact Us</h1>
                    <p className="contact-intro">We'd love to hear from you! Please fill out the form below and we'll get back to you as soon as possible.</p>

                    <form onSubmit={handleSubmit} className="contact-form">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your name"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="your@email.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Your message here..."
                                rows="6"
                                required
                            ></textarea>
                        </div>

                        {submitStatus && (
                            <div className={`submit-status ${submitStatus.type}`}>
                                {submitStatus.message}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
